import { Breadcrumbs, styled } from '@mui/material';
import theme from 'themes';

export const StyledBreadcrumbs = styled(Breadcrumbs)`
  width: 100%;
  & a {
    color: ${theme.palette.primary.main};
    text-decoration: none;
    line-height: 1.5;
    font-size: 16px;
    font-weight: 600;
    &:hover {
      text-decoration: underline;
    }
  }
  & p {
    color: ${theme.palette.text.secondary};
    font-weight: 600;
  }

  & .MuiBreadcrumbs-separator {
    color: ${theme.palette.primary.main};
    line-height: 1;
    margin: 0;
  }
`;
